import MaskedInput from "react-text-mask";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import Male from "../Investment/Images/Group3635.svg";
import Female from "../Investment/Images/Group3639.svg";
import React from "react";
import axios from "axios";
import { useFormik } from 'formik';
import { calculateAge, formatDate, getAge, getAnnualIncome, getAnnualIncomeList, getMaskForNameWithMaxLength, getPaymentTermList, getMobileValidationError } from "./UtilityComponents/UtilityFunction";
import { basePath } from "../index";
import 'react-datepicker/dist/react-datepicker.css';
import CustomDatePicker from "./UtilityComponents/CustomDatePicker";
import GoogleRating from "./UtilityComponents/GoogleRating"
import CustomDropdown from "./UtilityComponents/CustomDropdown";
import PublicDataStats from "./UtilityComponents/PublicDataStats";

//const initialValues = {
//    MobileNo: "9876547654",
//    Gender: "M",
//    paymentTerm: "10",
//    anualIncome: "1500000",
//    DOB: "",
//    Age: "",
//    Name: "Test Test",
//    Email: "testing123@gmail.com",
//    isChildPlan: false,
//    ChildName: '',
//    ChildGender: 'M',
//    ChildDOB: ''
//}

// Value ko mask karne ka helper (sirf display ke liye, formik value real hi rehti hai)
const maskValue = (fieldName, value) => {
    const val = String(value || "");
    if (!val) return val;

    if (fieldName === "MobileNo") {
        // Last 4 digits dikhao, baaki mask
        return val.length > 4 ? "*".repeat(val.length - 4) + val.slice(-4) : val;
    }

    if (fieldName === "Email") {
        const atIndex = val.indexOf("@");
        if (atIndex <= 0) return "*".repeat(val.length);
        const local = val.slice(0, atIndex);
        const domain = val.slice(atIndex);
        const visible = local.slice(0, Math.min(2, local.length));
        return visible + "*".repeat(Math.max(local.length - visible.length, 0)) + domain;
    }

    if (fieldName === "Name") {
        // Har word ka pehla letter dikhao, baaki mask
        return val
            .split(" ")
            .map((word) => (word ? word[0] + "*".repeat(word.length - 1) : word))
            .join(" ");
    }

    return val;
};

const EditDetails = ({ RequestType }) => {

    const [agree, setAgree] = useState(false);
    const [isBtnActive, setIsBtnActive] = useState(false);

    const [BtnVal, setBtnVal] = useState("Get Quotes");

    // Kaun se fields abhi masked dikh rahe hain
    const [maskedFields, setMaskedFields] = useState({
        Name: true,
        MobileNo: true,
        Email: true
    });
    // Masked field pe focus aane ke baad real input pe autoFocus dene ke liye
    const focusAfterUnmask = useRef(null);

    const initialValues = {
        MobileNo: "9876547654",
        Gender: "M",
        paymentTerm: "10",
        anualIncome: "1500000",
        DOB: "",
        Age: "",
        Name: "",
        Email: "testing123@gmail.com",
        isChildPlan: false,
        ChildName: '',
        ChildGender: 'M',
        ChildDOB: ''
    }

    const navigate = useNavigate();
    let previousPath = useLocation();
    //console.log(previousPath);
    let queryString;

    if (previousPath.pathname === "/participating-plan") {
        queryString = "participating";
    }
    else if (previousPath.pathname === "/guaranteed-investment") {
        queryString = "guaranteed";
    }
    else if (previousPath.pathname === "/") {
        queryString = "investment";
    }
    const annualIncomeList = getAnnualIncomeList();
    const paymentTermList = getPaymentTermList();

    const today = new Date();
    let maxDate = new Date(
        today.getFullYear() - 18,
        today.getMonth(),
        today.getDate(),
    )

    let minDate = new Date(
        today.getFullYear() - 65,
        today.getMonth(),
        today.getDate(),
    );

    const childMaxDate = new Date();
    childMaxDate.setDate(today.getDate() - 30);

    const childMinDate = new Date();
    childMinDate.setFullYear(today.getFullYear() - 13);


    useEffect(() => {
        let QuoteReq = sessionStorage.getItem('QuoteReq');
        if (QuoteReq) {
            QuoteReq = JSON.parse(QuoteReq);
            formik.setFieldValue('MobileNo', QuoteReq.MobileNo);
            formik.setFieldValue('Email', QuoteReq.Email);
            formik.setFieldValue('Gender', QuoteReq.Gender);
            formik.setFieldValue('paymentTerm', QuoteReq.PaymentTerm);
            formik.setFieldValue('annualIncome', QuoteReq.AnnualIncome);
            formik.setFieldValue('DOB', new Date(QuoteReq.DOB.split("-").reverse().join("-")));
            formik.setFieldValue('Age', QuoteReq.Age);
            formik.setFieldValue('Name', QuoteReq.FullName);
            formik.setFieldValue('ChildName', QuoteReq?.lifeAssuredDetails?.FullName);
            formik.setFieldValue('isChildPlan', QuoteReq?.lifeAssuredDetails?.isChildPlan);
            formik.setFieldValue('ChildGender', QuoteReq?.lifeAssuredDetails?.Gender);
            formik.setFieldValue('ChildDOB', new Date(QuoteReq?.lifeAssuredDetails?.DOB));
        } else {
            formik?.setFieldValue('DOB', maxDate);
            const url = new URLSearchParams(window.location.search);
            formik?.setFieldValue('MobileNo', url.has("mobileNo") ? url.get("mobileNo") : "");
        }
    }, []);

    const handleAge = (age) => {
        const userAge = calculateAge(age);
        formik.setFieldValue('Age', userAge);
    }

    const validateEmail = (email) => {
        var re = /^(([^<>()\[\]\\.,;#:`~\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const validate = (values) => {
        let errors = {};
        if (values.paymentTerm === "" || values.paymentTerm === "Payment Term") {
            errors["paymentTerm"] = "Select a payment term";

        }
        if (values.anualIncome === "" || values.anualIncome === "Annual Income") {
            errors["anualIncome"] = "Please select annual income";
        }
        if (values.DOB === "" || values.DOB === "Date of birth") {
            errors["DOB"] = "Select a date";
        }
        if (values.Name.trim() === "") {
            errors["Name"] = "Please enter name";
        }
        else if (values.Name.trim().length < 2) {
            errors["Name"] = "Please enter valid name";
        }
        //if (!values.MobileNo) {
        //    errors["MobileNo"] = "Please enter valid mobile number";
        //} else if (values.MobileNo.length !== 10) {
        //    errors["MobileNo"] = "Entered mobile number should be of 10 digits";
        //} else {
        //    const mobileError = getMobileValidationError(values.MobileNo);
        //    if (mobileError) {
        //        errors["MobileNo"] = mobileError;
        //    }
        //}
        //if (!(values.Email.trim())) {
        //    errors["Email"] = "Please enter email address";
        //} else if (!validateEmail(values.Email.trim())) {
        //    errors["Email"] = "Please enter valid email";
        //}

        return errors;
    }

    const formik = useFormik({
        initialValues,
        validate,
        validateOnMount: true,
        onSubmit: (values) => {
            setIsBtnActive(true);
            setBtnVal("Wait..");
            formSubmit();
        }
    });

    useEffect(() => {
        if (formik && formik?.values?.DOB) {
            handleAge(formik?.values?.DOB)
        }
    }, [formik?.values?.DOB])

    // ---------- Masking helpers ----------

    // Field masked tabhi dikhega jab flag on ho aur value empty na ho
    const isMasked = (fieldName) => maskedFields[fieldName] && !!formik.values[fieldName];

    // Blur par: touched mark karo, aur value valid hai to mask on kar do
    const handleFieldBlur = (e) => {
        const fieldName = e.target.name;
        formik.handleBlur(e);
        focusAfterUnmask.current = null;

        const fieldError = validate(formik.values)[fieldName];
        if (formik.values[fieldName] && !fieldError) {
            setMaskedFields((prev) => ({ ...prev, [fieldName]: true }));
        }
    };

    // Masked input pe focus/click aaye to mask hata do aur real input pe focus bhejo
    const unmaskField = (fieldName) => {
        focusAfterUnmask.current = fieldName;
        setMaskedFields((prev) => ({ ...prev, [fieldName]: false }));
    };

    // Masked (display-only) input
    const renderMasked = (fieldName, type = "text") => (
        <input
            type={type}
            className="inputText packageForm"
            name={fieldName}
            readOnly
            placeholder=" "
            value={maskValue(fieldName, formik.values[fieldName])}
            onFocus={() => unmaskField(fieldName)}
            onClick={() => unmaskField(fieldName)}
        />
    );

    // Get Quotes button disabled jab tak form valid nahi hai ya T&C checkbox check nahi hai
    const isGetQuotesDisabled = isBtnActive || !agree || !formik.isValid;

    const formSubmit = () => {
        window.sessionStorage.removeItem("QuoteReq");
        window.sessionStorage.removeItem("QuoteResponse");
        sessionStorage.clear();

        let Token = window.localStorage.getItem("token");
        if (Token != null) {

            let data = {
                Token: JSON.parse(Token).token,
            };
            try {
                axios.post(`central/centralcall/callreqwithheader`, { URL: "GetUserInfo", Req: data })
                    .then((Res) => {
                        GenerateEnquiry(Res.data.userID);
                    });
            } catch (err) {
                GenerateEnquiry(0);
            }
        } else {
            GenerateEnquiry(0);
        }
    }

    const GenerateEnquiry = (userId) => {
        const { MobileNo, Gender, paymentTerm, anualIncome, Email, DOB, Age, Name, ChildDOB, ChildGender, ChildName, isChildPlan } = formik.values;
        const isDefaultCase = RequestType !== 2 && RequestType !== 3;
        let QuoteReq = {
            EnquiryNo: "",
            DOB: (DOB.getDate() < 10 ? ("0" + DOB.getDate()) : DOB.getDate()) + "-" + ((DOB.getMonth() + 1) < 10 ? ("0" + (DOB.getMonth() + 1)) : (DOB.getMonth() + 1)) + "-" + DOB.getFullYear(),
            Gender: Gender,
            FullName: Name,
            //FullName: "Test Test",
            PaymentTerm: paymentTerm,
            PolicyTerm: RequestType === 2 ? "15" : RequestType === 3 ? "80" : 30,
            IncomeTerm: 0,
            ModelPremium: "50000",
            SumAssured: 6000000,
            AnnualIncome: anualIncome,
            PaymentFreq: "Y",
            PlanType: RequestType === 3 ? "IIM" : "LS",
            InvestmentType: RequestType === 3 ? "PP" : RequestType === 2 ? "GP" : "ML",
            //MobileNo: MobileNo,
            MobileNo: "",
            //Email: Email,
            Email: "testing123@gmail.com",
            IsSmoker: false,
            RequestType,
            Education: isDefaultCase ? "3~12th" : "",
            Occupation: isDefaultCase ? "1~Salaried" : "",
            IsAutoPay: true,
            lifeAssuredDetails: {
                DOB: formatDate(ChildDOB),
                Gender: ChildGender,
                FullName: ChildName,
                isChildPlan
            },
            PayoutFrequency: "Y"
        };


        let PlanRequest = {
            EnquiryNo: "",
            DoB: (DOB.getDate() < 10 ? ("0" + DOB.getDate()) : DOB.getDate()) + "-" + ((DOB.getMonth() + 1) < 10 ? ("0" + (DOB.getMonth() + 1)) : (DOB.getMonth() + 1)) + "-" + DOB.getFullYear(),
        };

        let Req = {
            MobileNo: MobileNo,
            Gender: Gender,
            PaymentTerm: paymentTerm,
            AnnualIncome: anualIncome,
            DOB: DOB.getFullYear() + "-" + ((DOB.getMonth() + 1) < 10 ? ("0" + (DOB.getMonth() + 1)) : (DOB.getMonth() + 1)) + "-" + (DOB.getDate() < 10 ? ("0" + DOB.getDate()) : DOB.getDate()),
            FullName: Name,
            Email: Email,
            Age: getAge(DOB),
            ModelPremium: "50000",
            ChildDOB,
            ChildGender,
            ChildName,
            isChildPlan
        };



        let EnqReq = {
            //MobileNo: MobileNo,
            MobileNo: "",
            UserID: userId,
            BusinessID: window.localStorage.getItem("BusinessID"),
            MacID: ""
        };
        const ReqModel = {
            URL: "Enquiry",
            Req: EnqReq
        }

        axios.post(`central/centralcall/callreqwithheader`, ReqModel)
            .then((res) => {
                if (res.data.StatusCode === 200) {
                    Req.EnquiryNo = res.data.Data.EnquiryNo;
                    QuoteReq.EnquiryNo = res.data.Data.EnquiryNo;
                    PlanRequest.EnquiryNo = res.data.Data.EnquiryNo;
                    QuoteReq.Age = Req.Age;
                    let InsurerList = res.data.Data.InsurerList;
                    sessionStorage.setItem('QuoteReq', JSON.stringify(QuoteReq));
                    sessionStorage.setItem('InsurerList', JSON.stringify(InsurerList));

                    navigate("/InvestmentQuotes", {
                        state: {
                            Request: Req,
                            QuoteReq,
                            InsurerList,
                            PlanRequest,
                            previousPath: queryString,
                        },
                    })
                } else {

                }
            })
            .catch((err) => {
                setBtnVal("Submit");
            });
    };

    return (
        <div className="InvestForm">
            <p className="MainFormContent">Please Enter Your Details</p>
            <form onSubmit={formik.handleSubmit}>
                <label className="labeltext">Gender</label>
                <div className="form-check-inline mb-3 mt-3">
                    <div className="radio-item">
                        <input
                            type="radio"
                            id="ritema"
                            name="Gender"
                            value="M"
                            checked={formik.values.Gender === "M"}
                            onChange={() => formik.setFieldValue('Gender', 'M')}
                        />
                        <label htmlFor="ritema">
                            {" "}
                            <img alt="" src={Male} className="IconPic" /> Male{" "}
                        </label>
                    </div>
                    <div className="radio-item">
                        <input
                            type="radio"
                            id="ritemb"
                            name="Gender"
                            value="F"
                            checked={formik.values.Gender === "F"}
                            onChange={() => formik.setFieldValue('Gender', 'F')}
                        />
                        <label htmlFor="ritemb">
                            {" "}
                            <img alt="" src={Female} className="IconPic" /> Female{" "}
                        </label>
                    </div>
                </div>

                {/* ---------- Full Name ---------- */}
                <div className="InvestmentForm mb-2">
                    {isMasked("Name") ? (
                        renderMasked("Name")
                    ) : (
                        <MaskedInput
                            className="inputText packageForm "
                            mask={getMaskForNameWithMaxLength(50)}
                            guide={false}
                            showMask={false}
                            autoFocus={focusAfterUnmask.current === "Name"}
                            {...formik.getFieldProps('Name')}
                            name="Name"
                            placeholder=" "
                            onKeyDown={(e) => {
                                const { value, selectionStart } = e.target;
                                if (e.key === ' ' && (selectionStart === 0 || value[selectionStart - 1] === ' ')) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                const processedValue = e.target.value
                                    .replace(/^\s+/, '')
                                    .replace(/\s{2,}/g, ' ');

                                formik.setFieldValue('Name', processedValue);
                            }}
                            onBlur={handleFieldBlur}
                        />
                    )}
                    <label className="InvestAnnualIncome" htmlFor="">Full Name</label>
                    {formik.touched.Name && formik.errors.Name ? <span className="Error-Text">{formik.errors["Name"]}</span> : null}
                </div>

                <div className="InvestmentForm mb-2">
                    <label className="customDropdownLable">Approx. Annual Income</label>
                    <CustomDropdown
                        options={annualIncomeList}
                        value={formik.values.anualIncome}
                        labelKey="name"
                        valueKey="code"
                        placeholder="Select Income"
                        onChange={(data) => formik.setFieldValue("anualIncome", data.code)}
                    />
                    {formik.touched.anualIncome && formik.errors.anualIncome ? <span className="Error-Text">{formik.errors["anualIncome"]}</span> : null}

                </div>

                <div className="InvestmentForm">

                    <label className="customDropdownLable">Pay for (years)</label>
                    <CustomDropdown
                        options={paymentTermList}
                        value={formik.values.paymentTerm}
                        labelKey="name"
                        valueKey="code"
                        placeholder="Select Payment Term"
                        onChange={(data) => formik.setFieldValue("paymentTerm", data.code)}
                    />

                    {formik.touched.paymentTerm && formik.errors.paymentTerm ? <span className="Error-Text">{formik.errors["paymentTerm"]}</span> : null}


                </div>

                <div className="InvestmentForm">

                    <CustomDatePicker onDateSelection={(date) => formik.setFieldValue('DOB', date)} {...formik.getFieldProps('DOB')} maxDate={maxDate} minDate={minDate} selectedDate={formik.values.DOB} />
                    <span className="DOBText">Date of Birth</span>
                    {formik.touched.DOB && formik.errors.DOB ? <span className="Error-Text">{formik.errors["DOB"]}</span> : null}
                    <small className="UserAge"><b>{formik?.values?.Age} years</b></small>
                </div>

                {/* ---------- Mobile Number ---------- */}
                {/*<div className="InvestmentForm">
                    {isMasked("MobileNo") ? (
                        renderMasked("MobileNo", "tel")
                    ) : (
                        <MaskedInput
                            type="tel"
                            className="inputText packageForm"
                            mask={[
                                /[6-9]/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                            ]}
                            guide={false}
                            showMask={false}
                            autoFocus={focusAfterUnmask.current === "MobileNo"}
                            {...formik.getFieldProps('MobileNo')}
                            name="MobileNo"
                            placeholder=" "
                            maxLength="10"
                            onBlur={handleFieldBlur}
                        />
                    )}
                    <label className="InvestAnnualIncome" htmlFor="">
                        Mobile Number
                    </label>
                    <img alt="" className="mob-icon" />
                    {formik.touched.MobileNo && formik.errors.MobileNo ? <span className="Error-Text">{formik.errors["MobileNo"]}</span> : null}
                </div>*/}

                {/* ---------- Email ---------- */}
                {/*<div className="InvestmentForm">
                    {isMasked("Email") ? (
                        renderMasked("Email")
                    ) : (
                        <input
                            type="text"
                            className="inputText packageForm"
                            required
                            name="Email"
                            placeholder=" "
                            maxLength={100}
                            autoFocus={focusAfterUnmask.current === "Email"}
                            {...formik.getFieldProps('Email')}
                            onChange={(e) => {
                                const validEmailChars = /^[a-zA-Z0-9@._-]*$/;
                                if (validEmailChars.test(e.target.value)) {
                                    formik.setFieldValue("Email", e.target.value);
                                }
                            }}
                            onBlur={handleFieldBlur}
                        />
                    )}
                    <label className="InvestAnnualIncome" htmlFor="">Email Address</label>
                    {formik.touched.Email && formik.errors.Email && <span className="Error-Text">{formik.errors["Email"]}</span>}
                </div>*/}

                <p className="privacy_policy_TC">
                    <input
                        type="checkbox"
                        id=""
                        checked={agree}
                        onChange={(e) => setAgree(e.target.checked)}
                    />
                    <label htmlFor="" className="mb-0">
                        <small>By clicking <strong>Get Quotes</strong> you accept our </small>{" "}
                        <span className="textcolor">
                            <a onClick={() => window.open("https://www.smcinsurance.com/corporate-governance-and-legal-policies#privacy", "_blank")}>
                                Privacy Policy
                            </a>
                        </span>{", "}
                        <span className="textcolor">
                            <a onClick={() => window.open("https://www.smcinsurance.com/corporate-governance-and-legal-policies#terms", "_blank")}>
                                Terms of Use
                            </a>
                        </span>{" "}
                        <small>and provide your consent for DND communications.</small>
                    </label>
                </p>

                <input
                    type="submit"
                    className={`FillData${isGetQuotesDisabled ? " FillData-disabled" : ""}`}
                    value={BtnVal}
                    onClick={formik.handleSubmit}
                    disabled={isGetQuotesDisabled}
                />


                <PublicDataStats />

            </form>
            <div className="ratingMob">
                <GoogleRating />
            </div>
        </div>
    );
};
export default EditDetails;